var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRectangle2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#FFFFFF;stroke-width:50;stroke-miterlimit:10;}\n\t.st1{display:none;fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#050505;stroke-width:50;stroke-miterlimit:10;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#FFFFFF;stroke-width:50;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.9,175.2c12.8-10.9,31.5-11.3,44.6-0.8l151.2,120.9c8.3,6.6,13.1,16.7,13.1,27.3v175.5 c0,19.3-15.7,35-35,35H204.2c-19.3,0-35-15.7-35-35V322.2c0-10.2,4.5-19.9,12.2-26.6L321.9,175.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.9,179.1c12.8-10.9,31.5-11.3,44.6-0.8l151.2,120.9c8.3,6.6,13.1,16.7,13.1,27.3V502c0,19.3-15.7,35-35,35 H204.2c-19.3,0-35-15.7-35-35V326.1c0-10.2,4.5-19.9,12.2-26.6L321.9,179.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M428.8,537H271.2c-57.4,0-104.4-47-104.4-104.4V275c0-57.4,47-104.4,104.4-104.4h157.6 c57.4,0,104.4,47,104.4,104.4v157.6C533.2,490,486.2,537,428.8,537z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle2);
export default __webpack_public_path__ + "static/media/rectangle-2.3616fc1a10b8a2a6222e65d29c69bd07.svg";
export { ForwardRef as ReactComponent };